import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const JoinUs = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  const handleMembershipClick = () => {
    if (isAuthenticated) {
      navigate('/membership'); // Navigate to membership page if already logged in
    } else {
      loginWithRedirect({
        appState: { returnTo: '/membership' }, // Redirect to membership page after login
        authorizationParams: {
          screen_hint: 'signup', // Show signup tab by default
        },
      });
    }
  };

  return (
    <section className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="order-2 md:order-1">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Rejoignez la Famille Québec Alimentation
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Rejoignez la famille Québec Alimentation et goûtez la différence. Local. Qualité. Commodité. Économies. Livré directement chez vous.
            </p>
            <button
              onClick={handleMembershipClick}
              className="bg-custom-red text-white px-8 py-3 rounded-full font-bold hover:bg-opacity-90 transition-colors text-lg"
            >
              Join Now
            </button>
          </div>
          <div className="order-1 md:order-2">
            <img 
              src="https://images.unsplash.com/photo-1607623814075-e51df1bdc82f?auto=format&fit=crop&q=80&w=1200"
              alt="Premium meat selection" 
              className="w-full rounded-lg shadow-xl h-64 sm:h-96 object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinUs;